import React from "react";
import type { FC } from "react";

import { useCoreInputTextStore } from "../../store/store";
import { createDisplayNameForCoreInputTextElement } from "../../utils/getDisplayName";
import { createTestIdForCoreInputTextElement } from "../../utils/getTestId";

import type { InputTextHintProps } from "../../types";

import classes from "./CoreInputTextHint.styl";

const INPUT_TEXT_HINT_TEST_ID = createTestIdForCoreInputTextElement("hint");

const CoreInputTextHint: FC<InputTextHintProps> = ({ children }) => {
    const { hintId, hintRef } = useCoreInputTextStore();
    return children ? (
        <label
            id={hintId}
            className={classes["hint"]}
            data-tsid={INPUT_TEXT_HINT_TEST_ID}
            ref={hintRef}
        >
            {children}
        </label>
    ) : null;
};

CoreInputTextHint.displayName =
    createDisplayNameForCoreInputTextElement("Hint");

export default CoreInputTextHint;
